<template>
  <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
    <PopupModal
      :isOpen="isOpen"
      :close="close"
      :popupInfo="selectedPopupInfo"
      :reload="reload"
      v-if="isOpen"
    />
    <b-row class="mt-2 mb-4">
      <b-col col="1">
        <b-input-group class="max-w-xl">
          <b-input-group-prepend>
            <b-form-select :options="selectOptions" v-model="search.keywordType"/>
          </b-input-group-prepend>
          <b-form-input id="inline-form-input-username"
                        placeholder="검색어를 입력하세요."
                        v-on:keyup.enter="handleSearch"
                        v-model="search.keyword">
          </b-form-input>
          <b-input-group-append>
            <Button :type="ButtonTypes.blue" :on-click="handleSearch" label="검색"/>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table :items="popupInfos" :fields="fields">
      <template #cell(button)="data">
        <button
          v-on:click="openModal(data.item)"
          class="btn btn-primary">
          상세
        </button>
      </template>
    </b-table>
    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="pageSize"
      @page-click="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api"
import customDate from "@/util/custom-date"
import PopupModal from "@/components/modals/PopupModal.vue";
import Button from "@/components/Button.vue";
import {ButtonTypes} from "@/util/enums";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    }
  },
  components: {
    Button,
    PopupModal
  },
  data() {
    return {
      popupInfos: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      isOpen: false,
      selectOptions: [
        {value: '', text: '전체',},
        {value: 'title', text: '제목',},
        {value: 'content', text: '내용',}
      ],
      fields: [
        {
          label: '대상',
          key: 'typeName'
        },
        {
          label: '노출위치',
          key: 'popupTarget'
        },
        {
          label: '타이틀',
          key: 'title',
        },
        {
          label: '상세',
          key: 'content',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "10%" },
        }
      ],
      selectedPopupInfo: null,
      search: {
        keywordType: '',
        keyword: '',
      }
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.keyword = query.keyword
    }
    if (query.keywordType) {
      this.search.keywordType = query.keywordType
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    getDate(date){
      return customDate.stringFormat(date)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(page)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.keyword) {
        query.keyword = this.search.keyword
      }
      if (this.search.keywordType) {
        query.keywordType = this.search.keywordType
      }
      
      this.$router.replace({ query })
    },
    getPagingList(page) {
      console.log('page',page)
      let param = {
        page: page,
        keywordType: this.search.keywordType,
        keyword: this.search.keyword,
      }
      
      api.lesson.popupInfos(param, (response) => {
        const {content, totalPages, totalElements} = response.data
        this.totalPage = totalPages
        this.currentPage = page
        this.totalRows = totalElements
        this.popupInfos = content
      })
    },
    openModal(lessonPopup) {
      this.selectedPopupInfo = lessonPopup
      this.isOpen = !this.isOpen
    },
    reload() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    close() {
      this.isOpen = !this.isOpen
      console.log(this.isOpen)
    }
  }
}
</script>
